import CaptionToggleButton from "@components/controls/CaptionToggleButton";
import PageDataContextService from "@core-ui/ContextServices/PageDataContext";
import toggleSignature from "@core-ui/toggleSignature";
import t from "@ext/localization/locale/translate";
import type { Editor } from "@tiptap/core";
import type { Node } from "@tiptap/pm/model";
import { GlassToolbarButton, GlassToolbarIcon } from "@ui-kit/GlassToolbar";
import type { Dispatch, RefObject, SetStateAction } from "react";

interface DrawioActionsProps {
	hasSignature: boolean;
	editor: Editor;
	node: Node;
	signatureRef: RefObject<HTMLInputElement>;
	openEditor: () => void;
	setHasSignature: Dispatch<SetStateAction<boolean>>;
}

const DrawioActions = ({
	editor,
	node,
	hasSignature,
	setHasSignature,
	signatureRef,
	openEditor,
}: DrawioActionsProps) => {
	const disabledEdit = !PageDataContextService.value.settings?.services?.["diagram-renderer"]?.endpoint;
	const editTooltip = disabledEdit ? t("diagram.error.no-diagram-renderer") : t("edit2");
	const signatureTooltip = t("signature");
	const updateAttributes = (attributes: Record<string, string>) => {
		editor.commands.updateAttributes(node.type, attributes);
	};

	const addSignature = () => {
		setHasSignature((prev) => toggleSignature(prev, signatureRef.current, updateAttributes));
	};

	return (
		<>
			<GlassToolbarButton
				aria-label={editTooltip}
				className="disabled:pointer-events-auto disabled:cursor-not-allowed"
				data-testid="drawio-edit"
				disabled={disabledEdit}
				onClick={openEditor}
				tooltipText={editTooltip}
			>
				<GlassToolbarIcon icon="pencil" />
			</GlassToolbarButton>
			<CaptionToggleButton
				active={hasSignature}
				caption={node.attrs.title}
				data-testid="drawio-signature"
				onToggle={addSignature}
				tooltipText={signatureTooltip}
			/>
		</>
	);
};

export default DrawioActions;
